<template>
  <div>
    <Title v-if="!isAdmin" :showMinister="true" :showService="true" />
    <Breadcrumb :links="breadCrumbData" />
    <Carrusel />
    <Main />
  </div>
</template>

<script>
import Title from "../../../components/private/Title";
import Breadcrumb from "@/components/tools/Breadcrumb.vue";
import { mapState } from "vuex";
import Carrusel from "../../../components/private/Carrusel.vue";
import Main from "./Main.vue";
export default {
  components: {
    Title,
    Breadcrumb,
    Carrusel,
    Main,
  },
  data() {
    return {
      breadCrumbData: null,

    };
  },
  computed: {
    ...mapState("sesion", ["usuario"]),
    isAdmin: function() {
      return this.usuario.username === process.env.VUE_APP_USER_ADMIN;
    },
  },
  methods: {
    setBreadcrumbData: function() {
      this.breadCrumbData = [
        {
          name: "Portada BGI",
          routeName: "bgi",
          routeParams: {
            idUsuario: this.usuario.id,
          },
        },
        {
          name: "Escritorio de Gestión Virtual",
          routeName: "buttons",
          routeParams: {
            idUsuario: this.usuario.id,
            idServicio: this.$route.params.idServicio,
          },
        },
        {
          name: "Recursos Financieros",
          routeName: "rHumanos",
          routeParams: {
            idServicio: this.$route.params.idServicio,
          },
        },
      ];
    },


  },
  mounted() {
    this.setBreadcrumbData();
  },
};
</script>
